// DMS pattern components
export const DMS_DEGREES_PATTERN = "-?\\d{1,3}(?:[.,]\\d+)?\\s*(?:°|deg)?";
export const DMS_MINUTES_PATTERN = "\\s*(?:\\d{1,2}(?:[.,]\\d+)?\\s*(?:'|m)?)?";
export const DMS_SECONDS_PATTERN = "\\s*(?:\\d{1,2}(?:[.,]\\d+)?\\s*(?:\"|s)?)?";
export const DMS_HEMISPHERE_PATTERN = "\\s*[NSEW]?";

// Regex for a single DMS token (degrees + optional minutes + optional seconds + optional hemisphere)
export const SINGLE_DMS_PATTERN = DMS_DEGREES_PATTERN + DMS_MINUTES_PATTERN + DMS_SECONDS_PATTERN + DMS_HEMISPHERE_PATTERN;
